// Common patterns to catch variations
const profanityList = [
  'damn', 'hell', 'shit', 'fuck', 'ass', 'bitch', 'crap', 'piss',
  // Add more words as needed
];

export const containsProfanity = (text: string): boolean => {
  const lowerText = text.toLowerCase();
  return profanityList.some(word => lowerText.includes(word));
};